import common from '../../common';
import { HTTP_METHODS, HTTP_RESPONSE } from '../../enums/http';

export default class ContractLookup {
    constructor(utils) {
        this.utils = utils;
    }
    async getTypeOfContracts() {
        let response = await common.getRequest({
            url: `/api/getContractType`,
            utils: this.utils
        });
        if(response.status === HTTP_RESPONSE.SUCCESS) {
            return response?.data?.data?.map(x => ({
                id: x.id,
                type_of_contract: x.name
            })) || []; 
        } else {
            return [];
        }
    }
    async saveTypeOfContract(inputs, method = HTTP_METHODS.POST) {
        let payload = {
            name: inputs.type_of_contract
        };
        return await common.saveRequest({
            method,
            url: method === HTTP_METHODS.POST ? `/api/addContractType` : `/api/updateContractType/${inputs.id}`,
            payload,
            utils: this.utils
        });
    }
    async deleteTypeOfContract(inputs) {
        return await common.deleteRequest({
            url: `/api/removeContractType/${inputs.id}`,
            utils: this.utils
        });
    } 
}